import throttle from 'lodash.throttle';

export const handleSyncScroll = refs => {
  refs.map((ref, index) => {
    let refsClone = [...refs];
    delete refsClone[index];
    ref.addEventListener('scroll', e => synchronize(e, refsClone));
  });
  setTimeout(() => synchronize({ target: refs[0] }, refs.slice(1)));
};

const synchronize = throttle((e, siblings) => {
  if (siblings && Array.isArray(siblings)) {
    siblings.map(s => {
      if (s) {
        s.scrollTop = e.target.scrollTop;
      }
    });
  }
}, 50);
